export default __webpack_public_path__ + "16bad62c6dc7aec8dfa6eff7cf02ecc8.png";